import * as React from "react";

import primaryColour from "../constants";

function SvgInfo(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;

  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={12} cy={12} r={9} fill={fill} />
      <rect x={3} y={3} width={18} height={18} rx={4} fill={fill} />
      <path
        d="M13.25 16.0619C13.25 16.7832 12.6904 17.368 12 17.368C11.3096 17.368 10.75 16.7832 10.75 16.0619V12.1436C10.75 11.4223 11.3096 10.8375 12 10.8375C12.6904 10.8375 13.25 11.4223 13.25 12.1436V16.0619Z"
        fill="white"
      />
      <path
        d="M13.25 8.22535C13.25 8.94669 12.6904 9.53144 12 9.53144C11.3096 9.53144 10.75 8.94669 10.75 8.22535C10.75 7.50402 11.3096 6.91926 12 6.91926C12.6904 6.91926 13.25 7.50402 13.25 8.22535Z"
        fill="white"
      />
    </svg>
  );
}

export default SvgInfo;
